<script>
  // Compact number tile for the Attention and Today panels.
  import { Link } from '@inertiajs/svelte'

  let { value = 0, label, title = undefined, href = null, highlight = false } = $props()

  const classes = $derived(
    `block rounded-box border px-3 py-2 ${highlight ? 'border-warning bg-warning/10' : 'border-base-300 bg-base-100'}`
  )
</script>

{#snippet body()}
  <div class="text-xl font-bold leading-tight">{value.toLocaleString()}</div>
  <div class="text-xs text-base-content/60">{label}</div>
{/snippet}

{#if href}
  <Link {href} {title} class="{classes} hover:shadow-sm transition-shadow">{@render body()}</Link>
{:else}
  <div {title} class={classes}>{@render body()}</div>
{/if}
